var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('Column',[_c('video',{class:_vm.$style.video,attrs:{"data-animation":"fade-up","controls":"","src":_vm.slice.primary.video.url}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }